import { HttpErrorResponse } from '@angular/common/http';

import { SuggestAi } from '@core/email-ai-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<SuggestAi>()(
  'SuggestAi',
  {
    customActions: adapter => ({
      fetchAiDisplaySuggestions: (state, payload: { id: number }) => adapter.markAsPending(state),
      fetchAiDisplaySuggestionsSuccess: (state, payload: SuggestAi) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      fetchAiDisplaySuggestionsFailed: (state, error: HttpErrorResponse) =>
        adapter.setError(state, error),
    }),
  },
);

const SuggestAiActions = <
  Pick<
    typeof actions,
    | 'fetchAiDisplaySuggestions'
    | 'fetchAiDisplaySuggestionsSuccess'
    | 'fetchAiDisplaySuggestionsFailed'
  >
>actions;

export {
  SuggestAiActions,
  namespace as SuggestAiNamespace,
  reducer as SuggestAiReducer,
  selectors as SuggestAiSelectors,
};
